export const FEATCH_ALERTS = 'FEATCH_ALERTS';
export const CLEAR_ALERTS = 'CLEAR_ALERTS';
export const NEW_ALERT = 'NEW_ALERT';
export const CHANGE_MUTE_NOTIFICATION = 'CHANGE_MUTE_NOTIFICATION';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
